import jsPDF from "jspdf";

const generarPDF = (body) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const margin = 15;
  let y = margin;

  
  // Functions

    const drawItem = (label, ok, m1, m2) => {
    pdf.text(label, margin + m1, y);
    pdf.setTextColor(ok ? 0 : 200, ok ? 150 : 0, 0);
    pdf.setFont("helvetica", "bold");
    pdf.text(ok ? "OK" : "X", margin + m2, y); 
    pdf.setTextColor(0, 0, 0); //reset
    pdf.setFont("helvetica", "normal");
    
  };

    const drawItemA = (label,ok, m1, m2) => {
    pdf.setFont("helvetica", "normal");
    pdf.text(label, margin + m1, y);
    y += 7;
    pdf.setFont("helvetica", "italic");
    pdf.text(ok ? ok : "", margin + m2, y, {maxWidth: 170}); 
    pdf.setTextColor(0, 0, 0); //reset
    
  };


  // HEADER
  pdf.setFontSize(16);
  pdf.setFont("helvetica", "bold");
  pdf.text("Check Van Flet", margin, y);
  y += 10;

  pdf.setFontSize(12);
  pdf.setFont("helvetica", "normal");
  pdf.text(`Date: ${body.date}`, margin, y);
  y += 9;
  pdf.text(`Check created by: ${body.userMail}`, margin, y);
  y += 9;
  pdf.text(`Vehicle Registration Number: ${body.vehicleRegistrationNumber}`, margin, y);
  y += 9;

  pdf.setDrawColor(0);
  pdf.setLineWidth(0.5);
  pdf.line(margin, y, 210 - margin, y);
  y += 10;

  //
   

 

  // Exterior Condition
  pdf.setFont("helvetica", "bold");
  pdf.text("Exterior Condition", margin, y);
  pdf.setFont("helvetica", "normal");
  y += 9;


  
  drawItem('.Bodywork:', body.bodyWork, 0, 22);
  drawItem(".Bodywork panels:", body.bodyWorkPanels, 80, 115);
  y += 9;

  drawItem(".Headlights:", body.headLights, 0, 23);
  drawItem(".Sidelights (Parking Lights):", body.sideParkingLights, 80, 132);
  y += 9;

  drawItem(".Indicators:", body.indicators, 0, 21);
  drawItem(".Brake Lights:", body.brakeLights, 80, 106);
  y += 9;

  drawItem(".Wipers:", body.wipers, 0, 16);
  drawItem(".Windscreen Washer:", body.windScreenWasher, 60, 101);
  drawItem(".Rear Wiper:", body.rearWiper, 120, 144 );
  y += 9;

  drawItem(".Hazard Warning Lights:", body.hazardWarningLights, 0, 46);
  drawItem(".Number Plate Light:", body.numberPlateLight, 60, 99);
  drawItem(".Fog Lights:", body.fogLights, 120, 143);
  y += 9;

  drawItem(".Tyres Condition:", body.tyreCondition, 0, 32);
  drawItem(".Tyres Pressure:", body.tyrePressure, 60, 92);
  drawItem(".Tyres Depth:", body.tyresDepth, 120, 146);
  y += 9;
  
  drawItem(".Valve caps:", body.valveCaps, 0, 24);
  drawItem(".Wheels:", body.wheels, 60, 77);
  drawItem(".Number Plates:", body.numberPlates, 120, 151);
  y +=9;

  drawItem(".Mirrors:", body.mirrors, 0, 16);
  drawItem(".Mirrors Clean:", body.mirrorsClean, 40, 68);
  drawItem(".Windows:", body.windows, 80, 100 );
  drawItem(".Windows Clean:", body.windowsClean, 120, 152);
  y += 12;

  // Under The Bonet
  pdf.setFont("helvetica", "bold");
  pdf.text("Under the Bonnet", margin, y);
  pdf.setFont("helvetica", "normal");
  y += 9;

  drawItem(".Engine Oil:", body.engineOil, 0, 23);
  drawItem(".Coolant:", body.coolant, 60, 77);
  drawItem(".Brake Fluid:", body.brakeFluid, 120, 145);
  y += 9;

  drawItem(".Power Steering Fluid:", body.powerSteeringFluid, 0, 42);
  drawItem(".Leaks: ", body.leaks, 80, 94);
  y += 12;

  // Interior Checks
  pdf.setFont("helvetica", "bold");
  pdf.text("Interior Checks", margin, y);
  pdf.setFont("helvetica", "normal");
  y += 9;

  drawItem(".Horn:", body.horn, 0, 12);
  drawItem(".Warning Lights:", body.warningLights, 80, 111);
  y += 9;

  drawItem(".Foot Brake:", body.footBrake, 0, 23);
  drawItem(".Parking Brake:", body.parkingBrake, 60, 89);
  drawItem(".Load Security:", body.loadSecurity, 120, 149);
  y += 9
  

  drawItem(".Driver Seat:", body.driverSeat, 0, 24);
  drawItem(".Pedals:", body.pedals, 40, 56);
  drawItem(".Steering Wheel:", body.steeringWheel, 70, 102);
  drawItem(".Seat Belts:", body.seatBelts, 120, 142);
  y += 12



  // Equipment
  pdf.setFont("helvetica", "bold");
  pdf.text("Documentation Equipment", margin, y);
  pdf.setFont("helvetica", "normal");
  y += 9;

  drawItem(".Vehicle Documentation:", body.vehiculeDocumentation, 0, 46);
  drawItem(".Warning triangle and high-visibility vest:", body.warningTrianguleHighVibilityVest, 80, 156);
  y += 9 
  drawItem(".First-aid kit:", body.firstAidKit, 0, 23);
  drawItem(".Fire extinguisher:", body.fireExtinguisher, 80, 114);
  y += 9 

  pdf.setDrawColor(0);
  pdf.setLineWidth(0.5);
  pdf.line(margin, y, 210 - margin, y);
  y += 9;


  drawItemA('Additional Report (optional):', body.anotherReport, 0, 0)

  pdf.save(`check-van-flet-${body.uid}.pdf`);
};

export default generarPDF;
